﻿define(['jquery', 'pubsub', 'ajaxUtility', 'mixpanelControl'],

	function ($, pubsub, ajaxUtility) {
		'use strict';


		function sendIM(e, data) {
			var config;
			config = {
				'method': 'POST',
				'url': '/Services/api/InstantMessage/Send'
			};

			ajaxUtility.publish2(e, data, config);
		}

		function getConversations(e, data) {
			var config;

			config = {
				'method': 'GET',
				'url': '/Services/api/InstantMessage/Conversations'
			};
			ajaxUtility.publish2(e, data, config);

		}

		function markConversationRead(e, data) {
			var config;
			config = {
				'method': 'POST',
				'url': '/services/api/instantMessage/markconversationread?conversationId=' + data.request.conversationId
			};
			ajaxUtility.publish2(e, data, config);
		}

		function getMessages(e, data) {

			var config;

			config = {
				'method': 'GET',
				'url': '/Services/api/InstantMessage/Conversation'
			};
			ajaxUtility.publish2(e, data, config);
		}

		pubsub.subscribe('uiHas.imAdd', sendIM);
		pubsub.subscribe('uiNeeds.ConversationsBrowse', getConversations);
		pubsub.subscribe('uiNeeds.imBrowse', getMessages);
		pubsub.subscribe('uiHas.markConversationRead', markConversationRead);

	}

);